module.exports = __webpack_public_path__ + "static/media/banner.43a90299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.jpg
// module id = 681
// module chunks = 2